/** Dispatched by the core HTTP client on 403/404 so access can be refetched in one place. */
export const ACCESS_STALE_EVENT = 'access:stale';
